'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zIndex = undefined;

var _dictionary = require('../dictionary');

var _dictionary2 = _interopRequireDefault(_dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = require('../variables.json'),
    $zIndexMap = _require.$zIndexMap; // =============================================================================
// Z-INDEX (Settings)
// =============================================================================
// Keep track of all your z-index values in one central location.
// -----------------------------------------------------------------------------


var zIndex = exports.zIndex = (0, _dictionary2.default)($zIndexMap, 'Unknown zIndex used in zIndex function');
//# sourceMappingURL=zIndex.js.map